// 公共常量

// 默认语言
export const DEFAULT_LANGUAGE = 'zh-CN';

// Token Key
export const TOKEN_KEY = 'spop_openatom_oatc_api_token';
